export const ACTIONS = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete"
};
